<template>
  <div class="canvas">
    <div class="biaoti">打卡记录查询</div>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="日期">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="年级">
        <el-select v-model="grade" placeholder="请选择年级" clearable>
          <el-option v-for="g in uniqueGrades" :key="g" :label="g" :value="g"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班级">
        <el-select v-model="classs" placeholder="请选择班级" clearable>
          <el-option v-for="c in filteredClasses" :key="c" :label="c" :value="c"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button type="success" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="pagedRecords" style="width: 100%">
      <el-table-column prop="studentName" label="姓名" width="180"></el-table-column>
      <el-table-column prop="schoolName" label="学校" width="180"></el-table-column>
      <el-table-column prop="stageName" label="学段" width="180"></el-table-column>
      <el-table-column prop="gradeName" label="年级" width="180"></el-table-column>
      <el-table-column prop="className" label="班级" width="180"></el-table-column>
      <el-table-column prop="checkinTime" label="打卡时间" width="180"></el-table-column>
    </el-table>

    <el-pagination
      background
      layout="total, prev, pager, next"
      :total="filteredTotalRecords"
      :page-size="pageSize"
      @current-change="handlePageChange">
    </el-pagination>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import axios from 'axios';
import * as XLSX from 'xlsx'; // 导入 SheetJS


const records = ref([]);
const filteredTotalRecords = ref(0); // 筛选后的总记录数
const pageSize = ref(10);
const currentPage = ref(1);
const dateRange = ref([]);
const grade = ref('');
const classs = ref('');

// 动态生成年级和班级数据
const uniqueGrades = computed(() => {
  return [...new Set(records.value.map(record => record.gradeName))];
});

const filteredClasses = computed(() => {
  if (!grade.value) {
    return [];
  }
  return [...new Set(records.value.filter(record => record.gradeName === grade.value).map(record => record.className))];
});

// 筛选后的记录
const filteredRecords = computed(() => {
  return records.value.filter(record => {
    const dateMatch = !dateRange.value.length || (new Date(record.checkinTime) >= new Date(dateRange.value[0]) && new Date(record.checkinTime) <= new Date(dateRange.value[1]));
    const gradeMatch = !grade.value || record.gradeName === grade.value;
    const classMatch = !classs.value || record.className === classs.value;
    return dateMatch && gradeMatch && classMatch;
  });
});

// 分页数据
const pagedRecords = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  return filteredRecords.value.slice(start, start + pageSize.value);
});

// 筛选后更新总记录数
watch(filteredRecords, (newRecords) => {
  filteredTotalRecords.value = newRecords.length;
});

const fetchRecords = () => {
  const token = localStorage.getItem('token');
  axios.get('https://xbxy.xiao-e.tech/api/student-checkin-info1', {
    headers: {
      Authorization: `${token}` // 假设 token 是从 Pinia 中获取的
    }
  })
    .then(response => {
      console.log(response);
      records.value = response.data.data.studentCheckinList.map(item => ({
        studentName: item.studentName,
        schoolName: item.schoolName,
        stageName: item.stageName,
        gradeName: item.gradeName,
        className: item.className,
        checkinTime: item.checkinTime
      }));
    })
    .catch(error => {
      console.error('Error fetching records:', error);
    });
};

const search = () => {
  currentPage.value = 1;
};

const reset = () => {
  dateRange.value = [];
  grade.value = '';
  classs.value = '';
  currentPage.value = 1;
};

const handlePageChange = (page) => {
  currentPage.value = page;
};

const exportData = () => {
  // 将筛选后的记录转换为工作表
  const worksheet = XLSX.utils.json_to_sheet(filteredRecords.value.map(record => ({
    '姓名': record.studentName,
    '学校': record.schoolName,
    '学段': record.stageName,
    '年级': record.gradeName,
    '班级': record.className,
    '打卡时间': record.checkinTime
  })));

  // 创建工作簿并添加工作表
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, '打卡记录');

  // 保存为 Excel 文件
  XLSX.writeFile(workbook, '打卡记录.xlsx');
};

watch([dateRange, grade, classs], () => {
  currentPage.value = 1;
});

fetchRecords();
</script>

<style scoped>
.demo-form-inline {
  margin-bottom: 20px;
}
.canvas {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 97%;
  position: relative;
}
.biaoti {
  font-family: 'Georgia', serif;
  color: #4396e5;
  font-size: 30px;
  font-weight: bold;
  padding: 15px;
}
</style>